import $ from "jquery";

const utilsBackBtn = () => {
    const init = () => {
        execute();
    };

    const execute = () => {
        $(function () {
            $("#terugBtn").click(function () {
                parent.history.back();
                return false;
            });
        });
    };

    init();
};

try {
    utilsBackBtn();
} catch (error) {
    console.error("utilsBackBtn", error);
}
